// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3O_L1","title":"BackImages_title__2tlNx","images":"BackImages_images__2xKLP"};